var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "bodyRef" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.gridl, false),
            [
              _c("tree", {
                attrs: {
                  "parent-tree": _vm.treeData,
                  "frame-id": _vm.frame_id,
                  types: _vm.types,
                },
                on: { frameId: _vm.getFrameId, getList: _vm.getList },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-col", _vm._b({}, "el-col", _vm.gridr, false), [
            _c(
              "div",
              { staticClass: "v-height-flag" },
              [
                _vm.search.length > 0
                  ? _c("oaFromBox", {
                      attrs: {
                        search: _vm.search,
                        alert: _vm.alertText,
                        dropdownList: _vm.dropdownList,
                        isViewSearch: false,
                        total: _vm.total,
                        title: "物资管理",
                        isAddBtn: true,
                      },
                      on: {
                        addDataFn: _vm.handleManage,
                        dropdownFn: _vm.dropdownFn,
                        confirmData: _vm.confirmData,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    staticClass: "mt10",
                    staticStyle: { width: "100%" },
                    attrs: {
                      height: _vm.tableHeight,
                      data: _vm.tableData,
                      "row-key": "id",
                      "default-expand-all": "",
                    },
                    on: { "selection-change": _vm.handleSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { type: "selection", width: "55" },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "number",
                        label: "物资编号",
                        "min-width": "150",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "name",
                        label: "物资名称",
                        "min-width": "100",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "units",
                        label: "规格型号",
                        "min-width": "100",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "cate.cate_name",
                        label: "物资分类",
                        "min-width": "100",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "record[0].price",
                        label: "物资单价(元)",
                        "min-width": "100",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "specs",
                        label: "计量单位",
                        "min-width": "80",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        pstatus: "",
                        label: "状态",
                        "min-width": "80",
                        "show-overflow-tooltip": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.status === 0
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                    },
                                    [_vm._v("未使用")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status === 1
                                ? _c("el-tag", { attrs: { size: "mini" } }, [
                                    _vm._v("已领用"),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status === 2
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "success", size: "mini" },
                                    },
                                    [_vm._v("已归还")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status === 3
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: { type: "warning", size: "mini" },
                                    },
                                    [_vm._v("维修中")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status === 4
                                ? _c(
                                    "el-tag",
                                    { attrs: { type: "danger", size: "mini" } },
                                    [_vm._v("已报废")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "remark",
                        label: "重要信息",
                        "min-width": "180",
                        "show-overflow-tooltip": "",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "describe",
                        label: _vm.$t("public.operation"),
                        fixed: "right",
                        width: "200",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["material:fixed:manage:record"],
                                      expression:
                                        "['material:fixed:manage:record']",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleRecord(scope.row)
                                    },
                                  },
                                },
                                [_vm._v("记录")]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  directives: [
                                    {
                                      name: "hasPermi",
                                      rawName: "v-hasPermi",
                                      value: ["material:fixed:manage:edit"],
                                      expression:
                                        "['material:fixed:manage:edit']",
                                    },
                                  ],
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleEdit(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("public.edit")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-dropdown",
                                { staticClass: "ml10" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-dropdown-link el-button--text el-button",
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.$t("hr.more")) +
                                          "\n                  "
                                      ),
                                      _c("i", {
                                        staticClass:
                                          "el-icon-arrow-down el-icon--right",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-dropdown-menu",
                                    { staticStyle: { "text-align": "center" } },
                                    [
                                      scope.row.status <= 2
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleMaterialData(
                                                    2,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("维修")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status === 3
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleMaterialData(
                                                    3,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("处理")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status !== 4
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleMaterialData(
                                                    1,
                                                    scope.row
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("报废")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status === 0 ||
                                      scope.row.status === 4
                                        ? _c(
                                            "el-dropdown-item",
                                            {
                                              nativeOn: {
                                                click: function ($event) {
                                                  return _vm.handleDelete(
                                                    scope.row.id
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "page-fixed" },
              [
                _c("el-pagination", {
                  attrs: {
                    "page-size": _vm.where.limit,
                    "current-page": _vm.where.page,
                    "page-sizes": [15, 20, 30],
                    layout: "total,sizes, prev, pager, next, jumper",
                    total: _vm.total,
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.pageChange,
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("add-material", {
        ref: "addMaterial",
        attrs: { "form-data": _vm.fromData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("receive", {
        ref: "receive",
        attrs: { "form-data": _vm.receiveData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("record", { ref: "record", attrs: { "form-data": _vm.recordData } }),
      _vm._v(" "),
      _c("return-material", {
        ref: "returnMaterial",
        attrs: { "form-data": _vm.returnData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("material-dialog", {
        ref: "materialDialog",
        attrs: { "from-data": _vm.materialData },
        on: {
          isOk: function ($event) {
            return _vm.handleSearch()
          },
        },
      }),
      _vm._v(" "),
      _c("export-excel", {
        ref: "exportExcel",
        attrs: {
          template: false,
          "save-name": _vm.saveName,
          "export-data": _vm.exportData,
        },
      }),
      _vm._v(" "),
      _c("oa-dialog", {
        ref: "oaDialog",
        attrs: {
          fromData: _vm.fromData1,
          formConfig: _vm.formConfig,
          formRules: _vm.formRules,
          formDataInit: _vm.formDataInit,
        },
        on: { submit: _vm.submit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }